import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import AnimateEntrance from '../helper/animate';
import { getCurrencySymbol } from '../helper/currencies';
import { Tween, Easing } from '@tweenjs/tween.js';

class BonusBuyPageController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.canBuy = !GameConfigs.doubleChance;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency, true);
		this.bonusBuyPrice = GameConfigs.config.buyfeatureprice;
		this.currentBet = GameConfigs.currentBet;
		this.interaction = true;
		this.enableButton = true;
		this.timeout = null;
		AnimateEntrance(this.vc);
		window.sm.play({ name: 'bonus_buy_quest_open_sfx' });
		if (this.vc[this.config.holder][this.config.items[0]]) {
			this.wrapper = this.vc[this.config.holder];
			this.setValue(this.currentBet);
			this.wrapper.yes_btn_wrapper.yes_btn.handler =
				this.handleBonusBuy.bind(this);
			this.wrapper[this.config.items[1]].text = GameConfigs.config.minfs;
			window.addEventListener(EVENTS.BET_UPDATE, this, false);
			window.addEventListener(EVENTS.MODAL, this, false);
			window.addEventListener(EVENTS.BONUS_BUY, this, false);
			window.addEventListener(EVENTS.DOUBLE_CHANCE, this, false);

			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				window.addEventListener('keydown', this, false);
			}
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			this.timeout = setTimeout(() => {
				//add event after a small delay when the component is rendered
				window.addEventListener(EVENTS.INTERACTION, this, false);
				clearTimeout(this.timeout);
			}, 100);
		} else {
			throw new Error(
				'BonusBuyPageController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	setValue(bet) {
		if (this.currency[1] === 'left') {
			this.wrapper.getChildByName(this.config.items[0]).text =
				this.currency[0] + (bet * this.bonusBuyPrice).toLocaleString();
		} else {
			this.wrapper.getChildByName(this.config.items[0]).text =
				(bet * this.bonusBuyPrice).toLocaleString() +
				(GameConfigs.auth.balance.currency === 'GEL' ? '' : ' ') +
				this.currency[0];
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.BET_UPDATE:
				this.betChanged(evt);
				this.interaction = false;
				break;
			case EVENTS.MODAL:
				this.modalChanged(evt);
				break;
			case EVENTS.DOUBLE_CHANCE:
				if (evt.detail.doubleChance) {
					if (GameConfigs.modal !== '') {
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					}
					this.removeEvents();
				}
				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					if (GameConfigs.modal !== '') {
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					}
					this.removeEvents();
				}
				break;
			case 'keydown':
				if (
					evt.keyCode === 27 ||
					(evt.keyCode === 32 && !GameConfigs.disabled.spin)
				) {
					if (GameConfigs.modal === 'bonus_buy') {
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					}
					this.removeEvents();
				}
				break;
			case EVENTS.INTERACTION:
				const target = this.vc[this.config.holder].getBounds();
				if (GameConfigs.modal === 'bonus_buy') {
					if (
						HELPERS.handleOutsideClick(
							target,
							evt.x,
							evt.y,
							'bonus_buy',
							this.interaction
						)
					) {
						window.removeEventListener(EVENTS.INTERACTION, this, false);
						this.removeEvents();
					} else {
						this.interaction = true;
					}
				}
				break;
			default:
				break;
		}
	}

	modalChanged(e) {
		if (e.detail.modal !== 'bonus_buy') {
			this.removeEvents();
		}
	}

	removeEvents() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		window.sm.play({ name: 'bonus_buy_quest_close_sfx' });
		window.removeEventListener(EVENTS.BET_UPDATE, this, false);
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.BONUS_BUY, this, false);
		window.removeEventListener(EVENTS.DOUBLE_CHANCE, this, false);
		window.removeEventListener('keydown', this, false);
	}

	animateDisable() {
		if (this.tween) {
			this.tween = null;
		} else {
			this.tween = new Tween(this.wrapper.yes_btn_wrapper)
				.to({ x: 5 }, 10)
				.yoyo(true)
				.repeat(5)
				.easing(Easing.Linear.None)
				.start();
		}
	}

	handleBonusBuy() {
		if (GameConfigs.betPlaced) {
			this.animateDisable();
			return;
		}
		if (this.enableButton) {
			const betData = {
				service: 'bet',
				data: {
					amount: GameConfigs.currentBet.toString(),
					doublefeaturechance: 0,
					buybonus: 1
				}
			};
			HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: true });
			HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: true });
			window.connectionProvider
				.asyncBet(JSON.stringify(betData))
				.then((response) => {
					if (response.data) {
						GameConfigs.bonusBuy = true;
					} else {
						HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: false });
						return;
					}
				})
				.catch((error) => {
					console.error('Error occurred while placing bet:', error);
				});
			this.enableButton = false;
		}
	}

	betChanged(e) {
		this.currentBet = e.detail.betAmount;
		this.setValue(this.currentBet);
	}
}
export default BonusBuyPageController;
